import { render, staticRenderFns } from "./CreateEmail.vue?vue&type=template&id=67701f73"
import script from "./CreateEmail.vue?vue&type=script&lang=js"
export * from "./CreateEmail.vue?vue&type=script&lang=js"
import style0 from "./CreateEmail.vue?vue&type=style&index=0&id=67701f73&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67701f73')) {
      api.createRecord('67701f73', component.options)
    } else {
      api.reload('67701f73', component.options)
    }
    module.hot.accept("./CreateEmail.vue?vue&type=template&id=67701f73", function () {
      api.rerender('67701f73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EmailAccounts/CreateEmail.vue"
export default component.exports